module.exports = __webpack_public_path__ + "img/supplier-011.eba7ee6e.png";